import type { SvgIconProps } from "ui/icons/SVGIcon";
import SVGIcon from "ui/icons/SVGIcon";

export default function IconErrorStop(props: SvgIconProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
      <g clipPath="url(#clip0_427_12362)">
        <path
          d="M9.07107 0.585787C8.696 0.210714 8.18729 2.42591e-07 7.65686 2.15052e-07L4.34315 4.30104e-08C3.81271 1.54713e-08 3.30401 0.210714 2.92893 0.585786L0.585787 2.92893C0.210714 3.30401 2.42591e-07 3.81271 2.15052e-07 4.34314L4.30104e-08 7.65685C1.54713e-08 8.18729 0.210713 8.69599 0.585786 9.07107L2.92893 11.4142C3.30401 11.7893 3.81271 12 4.34315 12L7.65685 12C8.18729 12 8.696 11.7893 9.07107 11.4142L11.4142 9.07107C11.7893 8.69599 12 8.18729 12 7.65685V4.34315C12 3.81271 11.7893 3.30401 11.4142 2.92893L9.07107 0.585787Z"
          fill="#F55D58"
        />
        <path d="M3.64355 8.35712L8.3576 3.64307" stroke="white" strokeWidth="1.33333" />
        <path d="M8.35742 8.35712L3.64338 3.64307" stroke="white" strokeWidth="1.33333" />
      </g>
      <defs>
        <clipPath id="clip0_427_12362">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </SVGIcon>
  );
}
